const formatResultDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const Race20Result = ({
  resultData
}) => {

  return (
    <div id="ResultsData" class="tabcontent" style={{ display: "block" }}>
      <div class="left-content" style={{ marginRight: "5px", marginLeft: "5px" }}>
        {resultData &&
          resultData.length > 0 &&
          resultData.map((dataObj, index) => {
            //let card = dataObj.c1;
            //let imgval1 = `/assets/images/cards/${dataObj.c1}.png`;

            let win1 = 'LOSER';
            let win2 = 'LOSER';
            let win3 = 'LOSER';
            let win4 = 'LOSER';


            if (dataObj.result == 1) {
              win1 = 'WINNER';
            }
            if (dataObj.result == 2) {
              win2 = 'WINNER';
            }
            if (dataObj.result == 3) {
              win3 = 'WINNER';
            }
            if (dataObj.result == 4) {
              win4 = 'WINNER';
            }

            let bgCls1 = (win1 == 'WINNER') ? 'bgwinner' : 'bgLoser';
            let bgCls2 = (win2 == 'WINNER') ? 'bgwinner' : 'bgLoser';
            let bgCls3 = (win3 == 'WINNER') ? 'bgwinner' : 'bgLoser';
            let bgCls4 = (win4 == 'WINNER') ? 'bgwinner' : 'bgLoser';

            let tdCls1 = (win1 == 'WINNER') ? 'TdResultsWin' : '';
            let tdCls2 = (win2 == 'WINNER') ? 'TdResultsWin' : '';
            let tdCls3 = (win3 == 'WINNER') ? 'TdResultsWin' : '';
            let tdCls4 = (win4 == 'WINNER') ? 'TdResultsWin' : '';

            let spades_cards = dataObj.spades_cards.split(",");
            let hearts_cards = dataObj.hearts_cards.split(",");
            let clubs_cards = dataObj.clubs_cards.split(",");
            let diamonds_cards = dataObj.diamonds_cards.split(",");

            return (
              <div
                class="card"
                style={{
                  border: "1px solid rgb(204, 204, 204)",
                  borderRadius: "8px",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                  marginBottom: "5px",
                  background: "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                  color: "white"
                }}
              >
                <div
                  class="card-header"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px",
                    marginTop: "10px",
                    marginLeft: "7px",
                    background: "transparent",
                    borderBottom: "solid 1px #000"
                  }}
                >
                  {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                </div>
                <div class="card-body">
                  <div
                    class="players-table"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>

                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            background: "transparent"
                          }}
                        >
                          <td className={`TdResults ${tdCls1}`}>
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                King of Spades
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                {spades_cards &&
                                  spades_cards.length > 0 &&
                                  spades_cards.map((card, index) => {
                                    card = (card) ? card : '1';
                                    const cardImage = `/assets/images/cards/${card}.svg`;
                                    return (
                                      <img
                                        src={cardImage}
                                        loading="lazy"
                                        style={{
                                          width: "40px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "5px"
                                        }}
                                      />
                                    );
                                  })}

                              </div>
                              <div
                                className={`player-status ${bgCls1}`}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {win1}
                              </div>
                            </div>
                          </td>

                          <td className={`TdResults ${tdCls2}`}>
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                King of Hearts
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                {hearts_cards &&
                                  hearts_cards.length > 0 &&
                                  hearts_cards.map((card, index) => {
                                    card = (card) ? card : '1';
                                    const cardImage = `/assets/images/cards/${card}.svg`;
                                    return (
                                      <img
                                        src={cardImage}
                                        loading="lazy"
                                        style={{
                                          width: "40px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "5px"
                                        }}
                                      />
                                    );
                                  })}

                              </div>
                              <div
                                className={`player-status ${bgCls2}`}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {win2}
                              </div>
                            </div>
                          </td>

                          <td className={`TdResults ${tdCls3}`}>
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                King of Clubs
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                {clubs_cards &&
                                  clubs_cards.length > 0 &&
                                  clubs_cards.map((card, index) => {
                                    card = (card) ? card : '1';
                                    const cardImage = `/assets/images/cards/${card}.svg`;
                                    return (
                                      <img
                                        src={cardImage}
                                        loading="lazy"
                                        style={{
                                          width: "40px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "5px"
                                        }}
                                      />
                                    );
                                  })}

                              </div>
                              <div
                                className={`player-status ${bgCls3}`}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {win3}
                              </div>
                            </div>
                          </td>

                          <td className={`TdResults ${tdCls4}`}>
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                King of Diamonds
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                {diamonds_cards &&
                                  diamonds_cards.length > 0 &&
                                  diamonds_cards.map((card, index) => {
                                    card = (card) ? card : '1';
                                    const cardImage = `/assets/images/cards/${card}.svg`;
                                    return (
                                      <img
                                        src={cardImage}
                                        loading="lazy"
                                        style={{
                                          width: "40px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "5px"
                                        }}
                                      />
                                    );
                                  })}

                              </div>
                              <div
                                className={`player-status ${bgCls4}`}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {win4}
                              </div>
                            </div>
                          </td>


                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}


      </div>
    </div>
  );
}

export default Race20Result;
